<template>
  <div id="app">
    <Menu1></Menu1>
    <router-view />
    <Foot1></Foot1>
  </div>
</template>

<script>
export default {
  name: 'App'
}
// import Vue from 'vue';
// import axios from 'axios';
// import gConfig from '../gConfig';
// Vue.prototype.gConfig = gConfig;
// Vue.prototype.axios = axios;
</script>

<style>
@import './assets/homeContent/global.css';
@import './assets/homeContent/index.css';
</style>



// WEBPACK FOOTER //
// src/App.vue